import { TextField as MuiTextField } from '@mui/material';
import { DropdownIcon } from '@/assets/Icons/DropdownIcon';
import { PSelectProps } from '@/components/atoms/Select/types';
import { lockedSelectFieldSx } from '@/components/atoms/TextField/lockedSx';
import { mergeSx } from '@/utils/cssStyles';

/**
 * `PSelect` is the design system atom for a single-choice dropdown.
 *
 * Wraps MUI's `TextField` in `select` mode and adds a third `state`: alongside
 * `enabled`/`disabled`, `locked` renders a readable filled treatment (instead of MUI's dimmed
 * disabled look) for a value the user needs to read but can't change right now.
 */
export const PSelect = ({ state = 'enabled', sx, SelectProps, ...other }: PSelectProps) => {
  return (
    <MuiTextField
      select
      disabled={state !== 'enabled'}
      sx={mergeSx(state === 'locked' ? lockedSelectFieldSx : undefined, sx)}
      SelectProps={{
        IconComponent: DropdownIcon,
        ...SelectProps,
        sx: mergeSx(SelectProps?.sx, {
          '& .MuiSelect-icon': {
            top: '50%',
            transform: 'translateY(-50%)',
            right: 8,
          },
        }),
      }}
      {...other}
    />
  );
};
